import request from '@/utils/request';
import { AxiosPromise } from 'axios';
import { SellerStoreVo, EnterpriseFlagVo, SellerCompanyCheckVo, StorePhoto } from '@/api/member/store-setting/types';

/**
 * 获取店铺信息
 */
export const getMemberStoreInfo = (): AxiosPromise<SellerStoreVo> =>
  request({
    url: '/member/store/info',
    method: 'get'
  });

/**
 * 更新店铺头像
 */
export const updateStoreAvatar = (data: { ossId: number | string }): AxiosPromise<StorePhoto> => {
  return request({
    url: '/member/store/avatar',
    method: 'post',
    data
  });
};
/**
 * 更新店铺名称
 */
export const updateStoreName = (data: { storeName: string }): AxiosPromise<boolean> => {
  return request({
    url: '/member/store/name',
    method: 'post',
    data
  });
};

/**
 * 个人卖家转企业标识
 */
export const getStoreEnterpriseFlag = (): AxiosPromise<EnterpriseFlagVo> =>
  request({
    url: '/member/store/enterpriseFlag',
    method: 'get'
  });
/**
 * 个人卖家转企业卖家 查看企业认证
 */
export const getStoreCheck = (): AxiosPromise<SellerCompanyCheckVo> =>
  request({
    url: '/member/store/check',
    method: 'get'
  });

/**
 * 更新店铺描述
 */
export const updateStoreDescription = (data: { description: string }): AxiosPromise<boolean> => {
  return request({
    url: '/member/store/description',
    method: 'post',
    data
  });
};

/**
 * 编辑店铺自动回复设置
 */
export const updateAutoReply = (data: { autoReplyFlag: number; autoReplyText?: string }): AxiosPromise<boolean> => {
  return request({
    url: '/member/store/editAutoReply',
    method: 'post',
    data
  });
};
/**
 * 更新店铺营业状态
 */
export const changeStoreTrade = (data: { tradeFlag: number }): AxiosPromise<boolean> => {
  return request({
    url: '/member/store/trade',
    method: 'post',
    data
  });
};
/**
 * 更新店铺是否开具发票
 */
export const changeMemberStoreInvoice = (data: { invoice: number }): AxiosPromise<boolean> => {
  return request({
    url: '/member/store/invoice',
    method: 'post',
    data
  });
};

/**
 * 更新店铺条款
 */
export const updateStoreTerms = (data: { terms: string }): AxiosPromise<boolean> => {
  return request({
    url: '/member/store/terms',
    method: 'post',
    data
  });
};
